module.exports = __webpack_public_path__ + "static/img/banner4.38adcc9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner4.jpeg
// module id = nG2Y
// module chunks = 1